// extracted by mini-css-extract-plugin
export var buttonCustomClass = "NSDC-module--buttonCustomClass--effd9";
export var buttonCustomTextClass = "NSDC-module--buttonCustomTextClass--440f9";
export var certificateCousel = "NSDC-module--certificateCousel--21e81";
export var container = "NSDC-module--container--3538c";
export var controlButtons = "NSDC-module--controlButtons--774d9";
export var left = "NSDC-module--left--0c0f7";
export var lmsScrollbar = "NSDC-module--lms-scrollbar--e809f";
export var right = "NSDC-module--right--65d64";
export var wrapper = "NSDC-module--wrapper--c19bb";